import { Utils } from '../../../../../../../core/utils/utils';
import { Injectable } from '@angular/core';
import { forkJoin, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import * as _ from 'lodash';
import { Typefinders } from '../../../../../../../core/entities/typefinders.model';
import { Wsdefs } from '../../../../../../../core/entities/wsdefs.model';
import { Applicationdefs } from '../../../../../../../core/entities/applicationdefs.model';
import { TypefindersService } from '../../../../../../../core/repositories/typefinders.service'
import { ONLINE_OPTIONS } from '../../../../../../../core/utils/constants';
import { InternalHomeService } from '../../../../../internal-home/internal-home.service';

@Injectable()
export class EditDialogsTypefindersService {

  typefinders: Typefinders = new Typefinders();
  originalTypefinders: Typefinders = new Typefinders();
  typefindersInput: Typefinders = new Typefinders();

  allTypefinders: Typefinders[] = [];
  changetitulo: boolean = false;

  onlineOption: any[] = ONLINE_OPTIONS;

  wsdefs: Wsdefs[] = new Array<Wsdefs>();
  applicationdefs: Applicationdefs[] = new Array<Applicationdefs>();

  typeSelectionWs: any[] = [{name: String, value:Boolean}];
  typeSelectionAp: any[] = [{name: String, value:Boolean}];

  constructor(private typefindersService: TypefindersService,
              private internalHomeService: InternalHomeService) { }

  /**
  * Inicia el dialog
  * @param data Datos recibidos por el dialog
  */
  init(data: any): Observable<boolean> {
    this.typefinders = data.typefinder;
    this.changetitulo = data.titulochange;
    this.originalTypefinders = _.cloneDeep(this.typefinders);
    console.log(data);

    return forkJoin({
        valor0: this.typefindersService.findAll(),
        valor1: this.internalHomeService.allWsdefs(),
        valor2: this.internalHomeService.allApplicationdefs()
    
      }).pipe(map(dataGroup => {

      this.allTypefinders = dataGroup.valor0 as Typefinders[];
      this.wsdefs = dataGroup.valor1;
      this.applicationdefs = dataGroup.valor2;

      /*gestión de los checkbox de wsdefs*/
      if(this.wsdefs.length > 0){
        for(let i = 0; i < this.wsdefs.length; i++){
          this.typeSelectionWs.push({name: this.wsdefs[i].code, value: false});
          if(this.typefinders.code === this.wsdefs[i].typefinder.code){
            this.typeSelectionWs[i].value = true;
          }
        }
      }else{
        for(let i = 0; i < this.wsdefs.length; i++){
          this.typeSelectionWs.push({name: this.wsdefs[i].code, value: false});
        }
      }

      /*gestión de los checkbox de applicationsdefs*/
      if(this.applicationdefs.length > 0){
        for(let i = 0; i < this.applicationdefs.length; i++){

          this.typeSelectionAp.push({name: this.applicationdefs[i].code, value: false});

          for(let j = 0; j < this.allTypefinders.length; j++){
            if (Utils.noUndfAndNull(this.applicationdefs[i].typefinders[j])) {
              if (this.typefinders.code === this.applicationdefs[i].typefinders[j].code) {
                this.typeSelectionAp[i].value = true;
              }
            }
          }
        }

      }else{
        for(let i = 0; i < this.applicationdefs.length; i++){
          this.typeSelectionAp.push({name: this.applicationdefs[i].code, value: false});
        }
      }

      if (Utils.noUndfAndNull(data.typefinder)) {
        this.typefinders = _.cloneDeep(data.typefinder);
      }

      return true;
    }));
  }


  /**
  * @description
  * Guarda el typefinder
  */
  public guardar(): Observable<any> {
    console.log('guardar');
    if (Utils.noUndfAndNull(this.typefinders.id, "")) {

      this.gestionCheckBox();
      /*comparamos el typefinder original con el modificado*/
      let compareTypefinder = this.compare(this.typefinders, this.originalTypefinders);

      if(compareTypefinder){
        return of(-1);
      }else{
        return this.typefindersService.postTypefinder(this.typefinders);
      }

    }else{
      this.gestionCheckBox();
      return this.typefindersService.postTypefinder(this.typefinders);
    }
  }

  /**
  * @description
  * Adecuamos los chekbox seleccionados con los wsdefs y los applicationdefs que corresponden
  */
  private gestionCheckBox(){
    for(let i = 0; i < this.typeSelectionWs.length; i++){
      for(let j = 0; j < this.wsdefs.length; j++){
        if(!this.typeSelectionWs[i].value && this.wsdefs[j] != null){
          if(this.typeSelectionWs[i].name === this.wsdefs[j].code){
            this.wsdefs.splice(j, 1);
            j--;
          }
        }
      }
    }

    for(let i = 0; i < this.typeSelectionAp.length; i++){
      for(let j = 0; j < this.wsdefs.length; j++){
        if(!this.typeSelectionAp[i].value && this.applicationdefs[j] != null){
          if(this.typeSelectionAp[i].name === this.applicationdefs[j].code){
            this.applicationdefs.splice(j, 1);
            j--;
          }
        }
      }
    }
    this.wsdefs = this.wsdefs.filter(Boolean);
    this.applicationdefs = this.applicationdefs.filter(Boolean);
    console.log(this.wsdefs);
    console.log(this.applicationdefs);
  }


  /**
  * @description
  * Comprueba si dos Typefinders son iguales.
  * @param datoX Typefinder 1
  * @param datoY Typefinder 2
  * @returns True si son iguales
  */
  public compare(itemX:Typefinders, itemY:Typefinders):boolean {
    //Ambos objetos están definidos y no son nulos
    if (Utils.noUndfAndNull(itemX) && Utils.noUndfAndNull(itemY)) {

      if (itemX.online !== null) {
        let value = itemX.online.toString();
        if (value === 'null') {
          itemX.online = 0;
        }
      }

      if (itemX.code !== "" && Utils.noUndfAndNull(itemX.online))
       return false;
    }
    //Uno de los objetos no está definido o es nulo mientras el otro sí está definido
    else if ((Utils.noUndfAndNull(itemX) && !Utils.noUndfAndNull(itemY)) || (!Utils.noUndfAndNull(itemX) && Utils.noUndfAndNull(itemY))) {
      return false;
    }
    return true;
  }

  /**
  * @description
  * Asigna a las propiedades del servicio sus valores por defecto
  */
  build() {
    this.typefinders = new Typefinders();
    this.typeSelectionWs = [];
    this.typeSelectionAp = [];
  }

}
